import React, {useState, useEffect } from 'react';
import Slider from "react-slick";
import Picture from 'Shared/Picture';
import PlayerYoutube from "../Shared/PlayerYoutube";

const Gallery = (props) => {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [mobileSliderHeight, setMobileSliderHeight] = useState(null);

    const singleImage = {
        ProductImage: {
            Value: props.detailsImage.Value
        },
        ProductImageAlt: {
            Value: props.detailsImageAlt.Value
        }
    };
    let items = [...props.productSlides, ...props.youtubeSlides];
    if (items.length < 1) {
        items.push(singleImage);
    }
    const slidesInNav = items.length > 5 ? 5 : items.length;
    const slidesInNavTablet = items.length > 3 ? 3 : items.length;

    const settingsNav = {
        infinite: true,
        vertical: true,
        asNavFor: nav2,
        slidesToShow: slidesInNav,
        slidesToScroll: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: slidesInNavTablet
                }
            }
        ]
    };
    const settings = {
        infinite: true,
        asNavFor: nav1,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        lazyLoad: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true
                }
            }
        ]
    };

    useEffect(() => {
        changeSliderHeight();
        window.addEventListener("resize", changeSliderHeight);
    }, []);

    const changeSliderHeight = () => {
        setMobileSliderHeight({height: document.body.clientWidth * 0.65 + "px"});
    };

    return (
        <div className="product-gallery" data-test="product-slider">
            {!props.isMobile && items.length > 1 && (
                <Slider
                    className="navigation"
                    {...settingsNav}
                    ref={slider => setNav1(slider)}
                >
                    {items.map((slide, index) => {
                        let image = slide.ProductImage ? (slide.ProductImage.Value) : slide.YoutubeThumbnail.Value;
                        let imageAlt = slide.ProductImageAlt ? slide.ProductImageAlt.Value : slide.YoutubeThumbnailAlt.Value;
                        return (
                            image !== null ? (
                                <Picture
                                    key={index}
                                    src={[
                                        {
                                            Url: image + "--resize,58,58",
                                            WebpUrl: image + "--resize,58,58--returnTypeFile,webp"
                                        },
                                        {
                                            Url: image + "--resize,58,58",
                                            WebpUrl: image + "--resize,58,58--returnTypeFile,webp"
                                        },
                                        {
                                            Url: image + "--resize,58,58",
                                            WebpUrl: image + "--resize,58,58--returnTypeFile,webp"
                                        }
                                    ]}
                                    alt={imageAlt}
                                />
                            ) : null
                        );
                    })}
                </Slider>
            )}
            <Slider
                className="mainSlider"
                {...settings}
                ref={slider => setNav2(slider)}
                style={props.isMobile ? mobileSliderHeight : null}
            >
                {items.map((slide, index) => (
                    <React.Fragment key={index}>
                        {slide.ProductImage && (
                            slide.ProductImage.Value !== null ? (
                                <Picture
                                    src={[
                                        {
                                            Url: slide.ProductImage.Value,
                                            WebpUrl: slide.ProductImage.Value + "--returnTypeFile,webp"
                                        },
                                        {
                                            Url: slide.ProductImage.Value,
                                            WebpUrl: slide.ProductImage.Value + "--returnTypeFile,webp"
                                        },
                                        {
                                            Url: slide.ProductImage.Value + "--resize,300,300",
                                            WebpUrl: slide.ProductImage.Value + "--resize,300,300--returnTypeFile,webp"
                                        }
                                    ]}
                                    alt={slide.ProductImageAlt.Value}
                                    mobileWidth="440"
                                    mobileHeight="440"
                                />
                            ) : null
                        )}
                        {slide.YoutubeUrl && (
                            <PlayerYoutube
                                youtubeUrl={slide.YoutubeUrl.Value}
                                teaserId={slide.Id}
                                teaser={slide}
                                teaserClass={""}
                                visibleByDefault={true}
                            />
                        )}
                    </React.Fragment>
                ))}
            </Slider>
        </div>
    );
}
export default Gallery;
